import { useAuth } from "../hooks/useAuth";
import { Navigate } from "react-router-dom";

export const Secret = () => {
  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
  };

  return (
    <div>
      <h1>This is a Secret page</h1>
      <button onClick={handleLogout}>Logout</button>
    </div>
  );
};
export const ProtectedRoute = ({ children, redirectTo = "/" }) => {
    const { isLoggedIn } = useAuth();
    if (!isLoggedIn) {
      if (redirectTo.startsWith("http")) {
        window.location.href = redirectTo;
        return null;
      }
      return <Navigate to={redirectTo} />;
    }
    return children;
  };
